import { styled, Stack, Slide } from '@mui/material';
import { lightColorPalette } from '@linearb/linui-common';

export const StyledIterationSummary = styled(Stack)`
  height: 100%;

  & main {
    font-size: 1.2rem;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    border: 1px solid ${lightColorPalette.lbBlue_20};
    border-radius: ${({ theme }) => theme.spacing(1.5)};
    margin-top: ${({ theme }) => theme.spacing(2.75)};
    padding: ${({ theme }) => theme.spacing(2.75)};
    overflow: auto;
    color: ${lightColorPalette.lbTextSubdued};
    letter-spacing: normal;
    line-height: 1.7rem;
    max-height: calc(100% - 200px);

    & div {
      padding-bottom: ${({ theme }) => theme.spacing(2)};
    }

    & p {
      padding-top: ${({ theme }) => theme.spacing(0.5)};
      padding-bottom: ${({ theme }) => theme.spacing(0.5)};
      margin-top: ${({ theme }) => theme.spacing(0)};
      margin-bottom: ${({ theme }) => theme.spacing(0)};
    }

    & h2 {
      margin-bottom: ${({ theme }) => theme.spacing(0)};
      margin-top: ${({ theme }) => theme.spacing(0)};
      font-weight: bold;
    }

    & h3 {
      margin-bottom: ${({ theme }) => theme.spacing(0)};
      margin-top: ${({ theme }) => theme.spacing(0)};
      font-weight: bold;
    }

    & h4 {
      margin-top: ${({ theme }) => theme.spacing(0.5)};
    }

    & ol {
      margin-left: ${({ theme }) => theme.spacing(1.5)};
      list-style: decimal;
      color: ${lightColorPalette.lbTextSubdued};
      padding-left: ${({ theme }) => theme.spacing(2)};
      padding-bottom: ${({ theme }) => theme.spacing(0.5)};
    }

    & ul {
      margin-left: ${({ theme }) => theme.spacing(2)};
      list-style: disc;
      margin-top: ${({ theme }) => theme.spacing(0.5)};
      padding-bottom: ${({ theme }) => theme.spacing(0.5)};
    }

    & li {
      color: inherit;
      margin-bottom: ${({ theme }) => theme.spacing(0.75)};
    }

    & li:last-child {
      margin-bottom: 0;
    }

    & a {
      text-decoration: underline;
      color: ${lightColorPalette.lbBrightBlue_100};
    }

    & a:hover {
      text-decoration: underline;
      color: ${lightColorPalette.lbLink};
    }
  }
`;

export const StyledSlide = styled(Slide)`
  padding: ${({ theme }) => theme.spacing(2.75)};
  width: 35%;
  background-color: ${lightColorPalette.lbWhite};
  position: absolute;
  right: 0;
  top: 7.5rem;
  bottom: 0;
  z-index: ${({ theme }) => theme.zIndex.drawer};
  overflow-y: auto;
`;

export const StyledListSkeleton = styled(Stack)`
  border: 1px solid ${lightColorPalette.lbBlue_20};
  border-radius: ${({ theme }) => theme.spacing(1.5)};
  margin-top: ${({ theme }) => theme.spacing(2.75)};
  padding: ${({ theme }) => theme.spacing(2.75)};
  height: 70%;
  background-color: ${lightColorPalette.lbBlue_5};
  margin-bottom: ${({ theme }) => theme.spacing(2.75)};
`;

export const IterationSummaryDisclaimer = styled(Stack)`
  width: calc(100% + 46px);
  color: ${lightColorPalette.lbSbGrey_80};
  text-align: center;
  background-color: ${lightColorPalette.lbBlue_10};
  border-bottom-right-radius: 10px;
  border-bottom-left-radius: 10px;
  font-size: 1rem;
  font-weight: 500;
  margin: 0 -${({ theme }) => theme.spacing(3)} -${({ theme }) =>
      theme.spacing(3)} -${({ theme }) => theme.spacing(3)};
  padding: 3px ${({ theme }) => theme.spacing(1)} 0
    ${({ theme }) => theme.spacing(1)} !important;
`;
